import { Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
    selector: 'app-slide-toggle',
    templateUrl: './slide-toggle.component.html',
    styleUrls: ['./slide-toggle.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => SlideToggleComponent),
            multi: true
        }
    ]
})
export class SlideToggleComponent implements ControlValueAccessor {
    @Input() disabled = false;
    @Input() ariaLabel: string;
    @Input() color: 'blue' | 'gold' = 'blue';
    @Input() mini = false;
    @Output() checkedChange = new EventEmitter<boolean>();

    checked = false;

    private onChange?: (value: boolean) => void;
    private onTouched?: () => void;

    writeValue(value: boolean): void {
        this.checked = !!value;
    }

    registerOnChange(onChange: (value: boolean) => void): void {
        this.onChange = onChange;
    }

    registerOnTouched(onTouched: () => void): void {
        this.onTouched = onTouched;
    }

    setDisabledState(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

    toggle(): void {
        if (this.disabled) {
            return;
        }
        this.checked = !this.checked;
        this.onChange?.(this.checked);
        this.onTouched?.();
        this.checkedChange.emit(this.checked);
    }
}
